<template>
  <v-content class="bg-content">
    <v-container grid-list-xl style="padding: 10px; top: 50px">
      <v-row class="mb-2">
        <v-col>
          <v-btn class="ma-2" @click="startRecording" :disabled="isRecording" color="primary" large>Start Recording</v-btn>
          <v-btn class="ma-2" @click="stopRecording" :disabled="!isRecording" color="error" large>Stop Recording</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="8">
          <v-textarea v-model="transcript" label="Notes" style="text-transform: toUpperCase;" outlined auto-grow rows="10" dark class="mb-2 transcript-textarea"></v-textarea>
        </v-col>
        <v-col cols="12" md="4">
          <v-card dark class="info-card" flat>
            <v-list>
              <v-list-item>
                <v-list-item-avatar>
                  <img :src="currentUser.profilePic">
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>File Name: {{ fileName }}</v-list-item-title>
                  <v-list-item-subtitle>Date: {{ currentDate }}</v-list-item-subtitle>
                  <v-list-item-subtitle>Author: {{ currentUser.name }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div class="highlighted-notes">
              <div v-for="note in savedNotes" :key="note.id" class="highlighted-note info-card">
                {{ note.text }}
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-chip class="ma-2">Speaking Time: {{ speakingTime }} seconds</v-chip>
          <v-chip class="ma-2">Word Count: {{ wordCount }}</v-chip>
        </v-col>
      </v-row>

      <v-divider class="my-8"></v-divider>
      <v-row>
        <v-col>
          <div dark class="saved-notes-card" outlined>
            <!-- <v-card-title class="text-h5">Saved Notes</v-card-title> -->
            <v-card-text>
              <v-btn outlined dark v-for="note in savedNotes" :key="note.id" @click="openNoteOverlay(note)" text>{{ note.fileName }}</v-btn>
            </v-card-text>
          </div>
        </v-col>
      </v-row>
      <v-overlay :value="showOverlay">
        <v-card dark class="overlay-card">
          <v-card-title>
            {{ overlayNote.fileName }}
            <v-avatar right>
              <img :src="overlayNote.profilePic">
            </v-avatar>
          </v-card-title>
          <v-card-text>{{ overlayNote.text }}</v-card-text>
          <v-card-actions>
            <v-btn color="green" @click="editNote(overlayNote)">Edit</v-btn>
            <v-btn color="red" @click="deleteNote(overlayNote.id)">Delete</v-btn>
            <v-btn color="red" @click="showOverlay = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-overlay>
    </v-container>
  </v-content>
</template>

<script>
import submitAudio from '../assets/audio/input3.wav';
import submitAudio2 from '../assets/audio/input5.wav';
export default {

  data() {
    return {
      transcript: '',
      isRecording: false,
      savedNotes: [],
      recognition: null,
      timer: null,
      speakingTime: 0,
      wordCount: 0,
      fileName: 'New Note',
      currentDate: new Date().toLocaleDateString(),
      sessionId: null,
      showOverlay: false,
      overlayNote: {},
      currentUser: JSON.parse(localStorage.getItem("currentUser")) || { name: 'Anonymous', profilePic: '', email: '' },
      listMode: false,
      listType: null,
      needCapital: false,
    };
  },
  methods: {
    startRecording() {
      setTimeout(() => {
        this.transcript = 'You can start speaking now.';
        setTimeout(() => {
        new Audio(submitAudio).play();
      }, 100);
      }, 1200);
      this.transcript = '';
      this.speakingTime = 0;
      this.wordCount = 0;
      this.recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
      this.recognition.continuous = true;
      this.recognition.interimResults = true;
      this.recognition.lang = 'en-US';

      let finalTranscript = '';

      this.recognition.onresult = event => {
        let interimTranscript = '';
        for (let i = event.resultIndex; i < event.results.length; ++i) {
          const transcriptFragment = event.results[i][0].transcript.trim().toLowerCase();
          if (event.results[i].isFinal) {
            finalTranscript += this.handleVoiceCommands(transcriptFragment);
          } else {
            interimTranscript += this.handleVoiceCommands(transcriptFragment, true);
          }
        }
        this.updateFileName(this.transcript);
        this.transcript = finalTranscript + interimTranscript;
        this.wordCount = this.transcript.trim().split(/\s+/).length;
      };

      this.recognition.start();
      this.isRecording = true;
      this.timer = setInterval(() => {
    this.autoSave();
    this.speakingTime += 15;  // Increment speaking time every 30 seconds
  }, 15000);
    },
    handleVoiceCommands(fragment, isInterim = false) {
  let result = ''; // Initialize result to return empty string instead of undefined

  if (!this.listMode) {
    const command = this.parseCommand(fragment);
    if (command !== null) {
      result = typeof command === 'function' ? command() : command; // Execute or append command result
    } else if (fragment.startsWith('create list')) {
      this.listMode = true;
      this.listType = 'bullet'; // Setup for bullet list
      result = '\n• '; // Start a new list with an empty bullet point
      setTimeout(() => {
        new Audio(submitAudio2).play();
      }, 500);
      // Optionally, you can play a sound or notify the user that list mode has started
    } else if (fragment === 'stop recording') {
      this.stopRecording();
      setTimeout(() => {
        new Audio(submitAudio).play();
        this.sessionId = null;  // Reset session ID after saving
      this.transcript = ''; 
      }, 3000);
      if (this.needCapital) {
        fragment = this.capitalizeFirstLetter(fragment);
      }
      this.needCapital = fragment.endsWith('.');  // Set flag if the fragment ends with a period
      return fragment;
    } else {
      result = isInterim ? '' : ' ' + fragment; // Handle normal speech, adding only if not interim
    }
  } else {
    if (fragment === 'list completed') {
      this.listMode = false;
      result = '\n'; // End the list
      // Optionally, you can play a sound or notify the user that list mode has ended
    } else {
      result = '\n• ' + fragment; // Continue adding to the list
    }
  }

  this.transcript += result; // Append the result to the transcript directly
  return result; // Return the result to be used wherever needed
},
capitalizeFirstLetter(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },

    parseCommand(fragment) {
      const commands = {
        'period': '.',
        'exclamation point': '!',
        'question mark': '?',
        'comma': ',',
        'semicolon': ';',
        'colon': ':',
        'space': ' ',
        'enter': '\n',
        'backspace': this.backspace,
        'tab': '\t'
      };
      return commands[fragment] || null;
    },
    backspace() {
      this.transcript = this.transcript.length > 0 ? this.transcript.slice(0, -1) : this.transcript;
    },
    stopRecording() {
      if (this.recognition) {
        this.recognition.stop();
      }
      this.isRecording = false;
      clearInterval(this.timer);
      this.autoSaveButton();
      console.log("Recording stopped.");
    },
    autoSaveButton() {
      console.log('Final Autosave before stopping');
      // this.autoSave();  // Call autoSave to handle the logic
      this.sessionId = null;  // Reset session ID after saving
      this.transcript = '';  // Clear the transcript after saving
      // alert("Recording stopped and data saved.");
    },
    autoSave() {
      if (this.sessionId) {
        // Update existing note
        const existingNote = this.savedNotes.find(note => note.id === this.sessionId);
        if (existingNote) {
          existingNote.text = this.transcript;
        }
      } else {
        // Create new note if there's no session ID
        this.sessionId = this.savedNotes.length + 1;
        this.savedNotes.push({
          id: this.sessionId,
          text: this.transcript,
          fileName: this.fileName,
          date: this.currentDate,
          currentUser: this.currentUser.name,
          profilePic: this.currentUser.profilePic
        });
      }
    },
    updateFileName(transcript) {
      const words = transcript.trim().split(/\s+/);
      if (words.length >= 6) {
        this.fileName = words.slice(0, 6).join(' ');
      } else {
        this.fileName = words.join(' ') || 'New Note';
      }
    },
    openNoteOverlay(note) {
      this.overlayNote = note;
      this.showOverlay = true;
    },
    editNote(note) {
      this.transcript = note.text;
      this.sessionId = note.id;
      this.showOverlay = false;
    },
    deleteNote(noteId) {
      this.savedNotes = this.savedNotes.filter(note => note.id !== noteId);
      this.showOverlay = false;
    }
  },
  mounted() {
    if (!('SpeechRecognition' in window || 'webkitSpeechRecognition' in window)) {
      console.error("This browser does not support desktop speech recognition.");
    }
  }
};
</script>


<style>
.transcript-textarea, .info-card, .saved-notes-card, .overlay-card {
  background-color: #001c3000;
  color: white;
  border-radius: 20px;
  font-size: 24px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      font-weight: normal;
      text-transform: lowercase;
  /* border: 1px solid #007bff; */
}
.transcript-textarea, .info-card, .saved-notes-card, .overlay-card:first-child {
  margin-top: 10px;
  text-transform: capitalize;

}
.highlighted-note {
  background-color: #009688;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
}
.overlay-card {
  max-width: 700px;
  min-width: 500px;
}
</style>
